import React from 'react';

interface IconProps {
	className?: string;
	style?: React.CSSProperties;
}


const CardsIcon = (props: IconProps) => {
	return (
		<svg
			fill="none"
			height="20"
			viewBox="0 0 21 20"
			width="21"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect
				height="5"
				rx="1"
				stroke="#8B8D94"
				strokeLinejoin="round"
				width="5"
				x="4.03711"
				y="3.33331"
			/>
			<rect
				height="5"
				rx="1"
				stroke="#8B8D94"
				strokeLinejoin="round"
				width="5"
				x="4.03711"
				y="11.6667"
			/>
			<rect
				height="5"
				rx="1"
				stroke="#8B8D94"
				strokeLinejoin="round"
				width="5"
				x="12.3711"
				y="11.6667"
			/>
			<rect
				height="5"
				rx="1"
				stroke="#8B8D94"
				strokeLinejoin="round"
				width="5"
				x="12.3711"
				y="3.33331"
			/>
		</svg>
	);
};

export default CardsIcon;
